
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "featurePlatformCheckEnabled": true,
  "featureOktaLoginEnabled": false,
  "featureDevModeAvailable": false,
  "npasUrl": "https://npas.vmedia.ca",
  "siteId": "178",
  "baseUrl": "https://a2.vmedia.ca",
  "applicationName": "FM-LGTV",
  "basePath": "./",
  "appVersion": "1.0.63",
  "buildCounter": "1222",
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "C:/tcagent/BuildAgent/work/f6010d7a8f2d88ad/applications/smart-application/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
